module.exports = __webpack_public_path__ + "static/media/team-kelvin.21f8209f.png";